export const module = {
  info: {
    name: 'voip-vendor-side-menu',
    caption: 'voip vendor side menu',
    viewGroup: 'general-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'Vendors',
    icon: 'el-icon-user-solid',
    routeName: 'module->voip-vendor->create',
    children: [
      {
        caption: 'Create Vendor',
        icon: 'el-icon-plus',
        routeName: 'module->voip-vendor->create'
      },
      {
        caption: 'List Vendors',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-vendor->list->page',
        routeParams: { listPage: 1}
      },
      {
        caption: 'Rates Panel',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-vendor->rates-panel->tab',
        routeParams: { tabName: 'uploadDocument'}
      }
    ]
  }
}

export default module
